import React from 'react';

/** Renders the Footer
 * @returns {String} - JSX representation of the component.
 */
const Footer = () => {
  return (
    <footer className="page-footer">
      <div className="footer-copyright">
        <div className="container">
          Powered by{' '}
          <a className="grey-text text-lighten-4" href="https://reddit.com">
            Reddit
          </a>
          <a
            className="grey-text text-lighten-4 right dot"
            href="https://jamesiv.es"
          >
            <span>Built by James Ives</span>
            <img src="./assets/jives.png" alt="James Ives" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js